import React from 'react';
import classnames from 'classnames/bind';
import { isEmpty } from 'lodash';
import { Button } from 'tuui';
import { ReactComponent as ChatAgentIcon } from 'modules/onboarding/OnboardingChatForm/components/InitWidget/welcome-message-icon.svg';
import { APP_EVENT_TYPE } from 'modules/taboola-common-frontend-modules/app-events-aggregator/appEventType';
import { useAppEventContext } from 'modules/taboola-common-frontend-modules/app-events-aggregator/hooks/useAppEventContext';
import { useChatAgentContext } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContext';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useMultiLayerPathParams } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';
import { useChatAgentPermitted } from '../../hooks/useChatAgentPermitted';
import styles from './chatAgentButtonBase.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ChatAgentButtonBase = ({
    eventType,
    eventData,
    id,
    messageId,
    className,
    isCompactMode,
    agentName,
    buttonClassName,
    buttonContentClassName,
    onClick,
    Icon = ChatAgentIcon,
}) => {
    //ToDo: merge messageId with id once chat agent is updated
    const { formatMessage } = useIntl();
    const { push: pushAppEvent } = useAppEventContext();
    const { openChat, setAgentName } = useChatAgentContext();
    const isChatAgentPermitted = useChatAgentPermitted();
    const { data: formData } = useFormDataContext();
    const { entity } = useMultiLayerPathParams();
    const pushAppFormdata = isEmpty(formData) || !entity ? undefined : { [entity]: formData };
    const userMessage = formatMessage({
        id: `user.message.${messageId}`,
        defaultMessage: 'I want to consult with Abby',
    });
    const displayText = formatMessage({
        id: messageId,
        defaultMessage: 'Consult with Abby',
    });

    const handleClick = () => {
        setAgentName(agentName);
        pushAppEvent({
            id,
            triggerName: agentName,
            displayText,
            type: eventType || APP_EVENT_TYPE.CLICK,
            data: eventData || pushAppFormdata,
        });
        openChat({ userMessage });

        if (onClick) {
            onClick();
        }
    };

    if (!isChatAgentPermitted) {
        return null;
    }

    return (
        <div className={classNameBuilder('container', className)}>
            <Button
                className={classNameBuilder('button', { compact: isCompactMode }, buttonClassName)}
                onClick={handleClick}
                data-app-event-visibility
                data-app-event-additional-data={JSON.stringify({ triggerName: agentName })}
                id={id}
            >
                <div className={classNameBuilder('button-content', buttonContentClassName)}>
                    {Icon && <Icon alt="abby-icon" className={styles['chat-agent-icon']} />}
                    <div className={classNameBuilder('text', { hidden: isCompactMode })}>
                        <span>{displayText}</span>
                    </div>
                </div>
            </Button>
        </div>
    );
};
